// Migration entry point for @nx/js:tsc build target.
// Migrations are registered in ../migrations.json and resolved by NX at runtime.
export {};
